import * as React from 'react';
import propz from 'propz';
import { FunctionComponent } from 'react';
import classNames from 'classnames';

interface Props {
  onCloseClick: () => void;
  onAcceptClick: () => void;
  isOpen: boolean;
  request: any;
}

export const AcceptRequestModal: FunctionComponent<Props> = props => {
  if (!props.isOpen) {
    return null;
  }

  const modalClasses = classNames({
    mDisplayBlock: props.isOpen,
    show: props.isOpen,
    modal: true,
    fade: true
  });

  const request = props.request;
  const email = propz.get(request, ['requester', 'email'], 'Not provided');
  const phone = propz.get(request, ['requester', 'phone'], 'Not provided');

  return (
    <div className={modalClasses}>
      <div className="modal-dialog modal-lg requestActionModal__dialog">
        <div className="modal-content requestActionModal">
          <div className="requestActionModal__head">
            <div className="requestActionModal__icon requestActionModal__icon--warning">!</div>
            <div>
              <h5>Please read carefully</h5>
              <p>Accepting this request grants access to school information.</p>
            </div>
            <button type="button" className="requestActionModal__close" onClick={props.onCloseClick} aria-label="Close">
              <span>&times;</span>
            </button>
          </div>

          <div className="requestActionModal__body">
            <p className="requestActionModal__intro">
              We use reasonable measures to check the identity of each user registering with Squad In Touch. Each user
              provides a mobile phone number and email address so their validity can be checked through confirmation
              codes.
            </p>

            <div className="requestActionModal__identityGrid">
              <div>
                <span>Email</span>
                <strong>{email}</strong>
              </div>
              <div>
                <span>Phone</span>
                <strong>{phone}</strong>
              </div>
            </div>

            <div className="requestActionModal__notice">
              It is the school's responsibility to satisfy itself that the user's identity has been verified before
              accepting a role request. If you are not completely satisfied the user is genuine, complete additional
              checks before granting permissions or decline this request.
            </div>
          </div>

          <div className="requestActionModal__foot">
            <button type="button" className="people-btn people-btn--secondary" onClick={props.onCloseClick}>
              Cancel
            </button>
            <button type="button" className="people-btn people-btn--primary" onClick={props.onAcceptClick}>
              Accept request
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

AcceptRequestModal.displayName = 'AcceptRequestModal';
